import { CSSProperties } from 'react';
import { LottieLoader } from '../../LottieLoader';
import { useNarrow } from '../../../lib/use-narrow';

/**
 * The wait, wherever the app is waiting: Symphony's own branded loop loader, centred. Fills its positioned
 * parent by default; pass `pane` for an opaque overlay over the CONTENT PANE.
 *
 * ONE indicator, with no way to ask for another — and the ONLY loader in the app: it's already on screen
 * during the signed-instance auth bootstrap (the page renders throughout it), so the wait from auth through
 * the dashboard load is one continuous animation with no separate auth cover to flash in and out.
 *
 * `pane` (not the whole viewport) because the rail is not what is loading: an overlay over everything made
 * the sidebar vanish and come back around each home load (measured at 3.3s of no rail). `.orion-pane-modal`
 * keeps the rail on screen throughout and zeroes the offset below 719px, where there is no rail.
 */
export function DashboardLoading({ pane = false }: { pane?: boolean } = {}) {
  const narrow = useNarrow();
  const indicator = <LottieLoader size={narrow ? 40 : 65} />;
  if (!pane) return <div style={styles.fill}>{indicator}</div>;
  return (
    <div className="orion-pane-modal" style={styles.pane}>
      {indicator}
    </div>
  );
}

const center: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'rgba(var(--ink-rgb), 0.55)',
};

const styles: Record<string, CSSProperties> = {
  fill: { ...center, position: 'absolute', inset: 0 },
  // Positioning comes from `.orion-pane-modal`; this only supplies the opaque field and the stacking.
  pane: { ...center, zIndex: 200, background: 'var(--field-color)' },
};
